import { ChecksForUnderstanding } from "./ChecksForUnderstanding";

export * from "./ChecksForUnderstanding";

export default ChecksForUnderstanding;
